"use client";

import { useState, useRef } from "react";
import Header from "./Compartido/Header";
import MapSection from "./Buscar/MapSection";
import FilterSection from "./Buscar/FilterSection";
import HotelList from "./Buscar/HotelList";
import HotelCard from "./Buscar/HotelCard";
import BrandsSection from "./Compartido/BrandsSection";
import Footer from "./Compartido/Footer";

import { useTranslation } from 'react-i18next';

const Buscar = (props) => {
    const [selectedDestination, setSelectedDestination] = useState("Barcelona");

    const { t } = useTranslation();

    return (
        <>
            <main className="min-h-screen">
                <Header
                    config={props.websgrupo}
                    lang={props.lang}
                    meta_titulo={props.meta_titulo}
                    meta_descripcion={props.meta_descripcion}
                    meta_keywords={props.meta_keywords}
                    ruta={props.ruta}
                    idiomas={props.idiomas}
                    destinos={props.destinos}
                    experiencias={props.experiencias}
                />
                <div >
                    {/* Map Section */}
                    <MapSection
                        hotels={props.propiedades.map(propi => ({ id: propi.id, name: propi.nombre, lat: propi.latitud, lng: propi.longitud }))}
                    />
                    <div className="container mt-4 mt-md-7">
                        <button type="button" aria-controls="collapse" className="mx-auto btn btn-primary d-flex d-md-none" aria-expanded="true"> {t("Ver filtros")}
                            <svg className="o-icon">
                                <use xlinkHref="#icon-filter" href="#icon-filter"></use>
                            </svg>
                        </button>
                        <div className="row">
                            <FilterSection
                                selectedDestination={selectedDestination}
                                onDestinationChange={setSelectedDestination}
                                destinos={props.destinos}
                                propiedades={props.propiedades}
                                destino={props.urldestino}
                                adultos={props.adultos}
                                ninos={props.ninos}
                                llegada={props.llegada}
                                salida={props.salida}
                            />

                            <HotelList
                                propiedades={props.propiedades}
                                ruta={props.ruta}
                                lang={props.lang}
                                destino={props.urldestino}
                                config={props.websgrupo}
                                adultos={props.adultos}
                                ninos={props.ninos}
                                llegada={props.llegada}
                                salida={props.salida}
                                moneda={props.moneda}
                                otraspropiedades={props.otraspropiedades}
                                nuevosadultos={props.nuevosadultos}
                            />

                        </div>
                    </div>
                </div >
            </main >
            <app-footer>

                <BrandsSection
                    lang={props.lang}
                    marcas={props.marcas}
                    ruta={props.ruta}
                />
                <Footer
                    lang={props.lang}
                    config={props.websgrupo}
                />
            </app-footer>
        </>
    );
}

export default Buscar;
